import styled from 'styled-components';
import {bannerFixedPosition} from 'components/BannerStack/positioning';
import IconCashbackCheckmark from 'assets/icon-cashback-checkmark.svg';

export const CashbackMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 20px;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }

  & > div:first-child {
    .DropInfo.DropInfoUpCashback {
      @media (min-width: 1001px) and (max-width: 1250px) {
        right: inherit;
        left: -36px;

        &::after {
          right: inherit;
          left: 14px;
        }
      }
    }
  }
`;

export const MetricCard = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 18px 22px;
  box-shadow: 0 8px 16px 0 #dddddd52;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MetricHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 16px;
  color: #2f3d48;
  position: relative;

  .info {
    margin-left: auto;
    color: #ff2d38;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    width: 18px;
    height: 18px;
    border: 1.5px solid #ff2d38;
    border-radius: 50%;
    justify-content: center;
    font-size: 12px;
    font-style: italic;
    font-weight: 600;
  }

  .iconWrap {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

export const MetricValue = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 42px;
  font-weight: 200;
  color: #2f3d48;
  line-height: 1.2;

  .trend {
    font-size: 14px;
    font-weight: 500;
    color: #17c981;
  }
  .trend.negative {
    color: #929cb9;
  }
`;

export const CashbackLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 25px;
  margin-top: 25px;

  @media (max-width: 1250px) {
    grid-template-columns: 1fr;
  }
`;

export const CashbackMainColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const CashbackSideColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const CashbackCard = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 24px 34px 27px 34px;
  box-shadow: 0 8px 16px 0 #dddddd52;
  @media (max-width: 767px) {
    padding: 18px 16px;
  }
`;

export const CardTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  color: #2f3d48;
  margin: 0;
`;

export const CardSubtitle = styled.p`
  font-size: 14px;
  color: #2f3d48;
  margin: 6px 0 0 0;
`;

export const RetentionBanner = styled.div`
  background-color: #ecf1fb;
  border: 2px solid #4671db;
  border-radius: 12px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 24px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .big {
    font-size: 67px;
    font-weight: 700;
    color: #4671db;
    line-height: 1;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    color: #2f3d48;
  }

  .desc {
    font-size: 14px;
    color: #2f3d48;
    margin-top: 4px;
  }
`;

export const ChartWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin-top: 24px;

  @media (max-width: 600px) {
    grid-template-columns: repeat(5, 1fr);
    gap: 8px;
  }
`;

export const ChartBarColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const ChartBarValue = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #2f3d48;
`;

export const ChartBar = styled.div`
  width: 100%;
  max-width: 100px;
  height: 120px;
  background-color: #eaecf3;
  border-radius: 8px;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: ${(props) => `${props.fillPercent || 0}%`};
    background-color: #17c981;
    transition: height 0.4s ease;
  }
`;

export const ChartBarLabel = styled.div`
  font-size: 14px;
  color: #929cb9;
  font-weight: 700;
`;

export const SidePanel = styled.div`
  background-color: #fff8e1;
  border: 2px solid #f5c95a;
  border-radius: 12px;
  padding: 24px 34px 27px 34px;

  &.success {
    background-color: #e4f6ed;
    border-color: #17c981;
  }

  .panelTitle {
    font-size: 20px;
    font-weight: 700;
    color: #2f3d48;
    margin: 0 0 8px 0;
  }

  .panelBody {
    font-size: 14px;
    color: #2f3d48;
    line-height: 1.5;

    .yellow {
      color: #f5a623;
    }
  }

  ul {
    margin: 10px 0 0 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  ul li {
    position: relative;
    padding-left: 14px;
    font-size: 14px;
    color: #2f3d48;
    line-height: 1.45;
  }

  ul li::before {
    content: '';
    position: absolute;
    left: 0;
    top: 7px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #f5a623;
  }

  ul li b,
  ul li strong {
    color: #f5a623;
    font-weight: 700;
  }
`;

export const InvestedBlock = styled.div`
  margin-top: 16px;
  display: grid;
  gap: 10px;
`;

export const InvestedBox = styled.div`
  border: 2px solid #17c981;
  border-radius: 10px;
  padding: 12px 16px;

  .label {
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 700;
    color: #2f3d48;
    letter-spacing: 0.5px;
  }

  .value {
    font-size: 32px;
    font-weight: 700;
    color: #17c981;
    margin-top: 4px;
  }

  .hint {
    font-size: 14px;
    color: #2f3d48;
    margin-top: 4px;
  }
`;

export const OrdersTable = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
`;

export const OrderRow = styled.div`
  display: grid;
  grid-template-columns: 40px 0.45fr 1fr 170px 80px;
  align-items: center;
  gap: 12px;
  padding: 12px 8px;
  border-bottom: 1px solid #eef0f4;
  font-size: 12px;
  color: #2f3d48;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 767px) {
    grid-template-columns: 40px 1fr auto;
    .order-amount,
    .order-date {
      display: none;
    }
  }

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: rgba(23, 201, 129, 0.1);
    color: #068954;
    font-weight: 700;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .name {
    font-weight: 700;
    color: #000000;
  }

  .order-info {
    color: #000000;
    text-align: left;
    display: flex;
    align-items: center;
  }

  .order-info b {
    color: #000000;
    font-weight: 700;
  }

  .order-credit-lines {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .order-types {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 10px;
  }

  .order-date {
    color: #929cb9;
    font-size: 12px;
    text-align: right;
  }
`;

export const OrderTypeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 999px;
  min-width: 80px;
  text-transform: capitalize;

  &.Earned {
    background-color: rgba(23, 201, 129, 0.15);
    color: #17c981;
  }

  &.Redeemed {
    background-color: rgba(70, 113, 219, 0.15);
    color: #4671db;
  }
`;

export const CashbackHeaderSubtitle = styled.div`
  margin-top: 6px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 24px;
  align-items: flex-start;
  column-gap: 6px;
  font-size: 17px;
  color: #000000;

  > span {
    min-width: 0;
  }

  .ButtonInfoDrop {
    flex: 0 0 auto;
    align-items: flex-start;
  }

  .DropInfoCashbackLimitedTime {
    width: 260px;
    right: -18px;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const DownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #ff2d38;
  font-weight: 700;
  font-size: 14px;
  padding: 6px 10px;
  border-radius: 8px;

  &:hover {
    background-color: rgba(255, 45, 56, 0.06);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EmptyOrders = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 100px 16px 178px 16px;
  gap: 12px;

  .title {
    font-size: 16px;
    font-weight: 700;
    color: #000000;
  }

  .desc {
    font-size: 15px;
    color: #737373;
    max-width: 280px;
  }

  .iconBg {
    margin-bottom: 12px;
    width: 86px;
    height: 86px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const EmptyHero = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 16px 0 #dddddd52;
  margin: 24px auto 0 auto;
  padding: 54px 32px 60px 32px;
  max-width: 680px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;

  @media (max-width: 767px) {
    padding: 28px 20px;
  }

  .heroTitle {
    font-size: 24px;
    font-weight: 700;
    color: #2f3d48;
  }

  .heroSubtitle {
    font-size: 14px;
    color: #000000;
  }

  ul {
    list-style: none;
    margin: 22px 0 0 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  ul li {
    display: flex;
    align-items: center;
    gap: 18px;
    font-size: 12px;
    color: #2f3d48;
    text-align: left;
  }

  ul li::before {
    content: '';
    flex: 0 0 32px;
    width: 32px;
    height: 32px;
    border-radius: 5px;
    background-image: url('${IconCashbackCheckmark}');
    background-repeat: no-repeat;
    background-position: center;
  }

  .heroActions {
    margin-top: 22px;
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    justify-content: center;

    & > button {
      min-width: 200px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      @media (max-width: 480px) {
        width: 100%;
        min-width: 0;
      }
    }
  }

  .limitedTimeNotice {
    margin-top: 2px;
    padding: 14px 18px;
    border-radius: 8px;
    background-color: rgba(227, 255, 244, 1);
    color: #2f3d48;
    font-size: 12px;
    line-height: 1.5;
  }
`;

export const EmptyChartPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 36px 16px 20px 16px;
  gap: 14px;

  .iconBg {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: rgba(146, 156, 185, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-size: 16px;
    font-weight: 700;
    color: #2f3d48;
  }

  .desc {
    font-size: 13px;
    color: #6b7785;
    max-width: 280px;
  }
`;

export const CashbackHeader = styled.div`
  width: 100%;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const CashbackModalTitle = styled.div`
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.2;
  color: #2f3d48;
`;

export const CashbackModalSubtitle = styled.div`
  margin-top: 18px;
  text-align: center;
  font-size: 14px;
  line-height: 1.4;
  color: #000000;
`;

export const CashbackSettingsBody = styled.div`
  margin-top: 34px;
`;

export const CashbackSettingsSection = styled.div`
  margin-top: 28px;

  &:first-child {
    margin-top: 0;
  }
`;

export const CashbackSectionTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 1.3;
  color: #000000;
`;

export const RequiredMark = styled.span`
  color: #ff2d38;
`;

export const CashbackSectionText = styled.div`
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.35;
  color: #2f3d48;
`;

export const CashbackFieldsRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) 132px;
  gap: 16px;
  margin-top: 15px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const CashbackField = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const CashbackInputWrap = styled.div`
  position: relative;

  input {
    width: 100%;
    border: 1px solid #d5d8de;
    border-radius: 6px;
    background-color: #f7f7fa;
    color: #2f3d48;
    font-family: 'Poppins';
    font-size: 16px;
    outline: none;
    padding: 0 40px 0 18px;
  }

  &.error input {
    border-color: #ba0302;
  }

  span {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    color: #2f3d48;
    font-size: 16px;
    pointer-events: none;
  }
`;

export const CashbackHint = styled.div`
  margin-top: 27px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #969ba0;
  font-size: 12px;
  line-height: 1.45;

  .icon {
    color: #ff2d38;
    width: 20px;
    line-height: 1;
  }

  .text {
    padding-left: 12px;
    border-left: 2px solid #ff2d38;
  }
`;

export const CashbackModalActions = styled.div`
  margin-top: 46px;
  display: grid;
  grid-template-columns: minmax(170px, 0.7fr) minmax(240px, 1.3fr);
  gap: 24px;
  align-items: center;

  button {
    width: 100%;
    min-height: 50px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const CashbackToggleBody = styled.div`
  margin-top: 50px;

  .ToggleRow {
    margin-top: 14px;
    display: flex;
    align-items: center;
  }

  .ToggleRow .MuiTypography-root {
    color: #2f3d48;
    font-size: 14px;
  }
`;

export const CashbackConfirmIntro = styled.div`
  max-width: 560px;
  margin: 18px auto 23px auto;
  text-align: center;
  font-size: 14px;
  line-height: 1.55;
  color: #000000;

  strong {
    font-weight: 700;
  }
`;

export const CashbackConfirmList = styled.div`
  display: grid;
  gap: 7px;
  max-width: 580px;
  margin: 0 auto;
`;

export const CashbackConfirmItem = styled.div`
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  align-items: flex-start;
  gap: 7px;

  .mark {
    width: 32px;
  }

  .copy {
    background-color: rgb(252, 166, 0, 0.1);
    border-radius: 8px;
    padding: 16px 13px;
    color: #2f3d48;
    font-size: 12px;
    line-height: 1.35;
  }

  strong {
    font-weight: 700;
  }
`;

export const CashbackDisableBannerWrapper = styled.div`
  ${bannerFixedPosition}
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ff2d38;
  padding: 8px 20px;

  @media (max-width: 767px) {
    padding: 5px 20px;
  }

  & > div {
    @media (max-width: 1440px) {
      font-size: 18px;
    }
    @media (max-width: 1300px) {
      font-size: 18px;
    }
    @media (max-width: 1000px) {
      font-size: 16px;
    }
    @media (max-width: 767px) {
      font-size: 13px;
    }
    @media (max-width: 599px) {
      font-size: 11px;
    }
  }

  svg {
    margin-right: 14px;
    flex: 0 0 auto;
    @media (max-width: 1000px) {
      width: 30px;
      height: 35px;
    }
    @media (max-width: 767px) {
      width: 24px;
      height: 29px;
      margin-right: 10px;
    }
    @media (max-width: 599px) {
      font-size: 11px;
    }
  }
`;

export const CashbackDisableBannerLink = styled.button`
  display: inline-block;
  font-style: normal;
  border: none;
  border-bottom: 1px solid #fff;
  transition-property: border-bottom-color;
  transition-duration: 0.3s;
  font-family: 'Poppins';
  color: #fff;
  cursor: pointer;
  background-color: transparent;
  font-size: 18px;
  font-weight: 700;
  margin-left: 5px;
  line-height: 1;

  @media (max-width: 1000px) {
    font-size: 16px;
  }
  @media (max-width: 767px) {
    font-size: 13px;
  }
  @media (max-width: 599px) {
    font-size: 11px;
  }
  &:hover {
    border-bottom-color: transparent;
  }
`;
